import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ViewDensityStandardIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="viewDensityStandard" ref={ref} {...props}>
    <path d="M5.193,16.712H18.8a1.953,1.953,0,0,0,1.95-1.95v-5.3a2.254,2.254,0,0,0-2.25-2.25H5.193a1.944,1.944,0,0,0-1.94,1.951v5.6A1.944,1.944,0,0,0,5.193,16.712Zm-.44-7.549a.447.447,0,0,1,.44-.451H18.5a.755.755,0,0,1,.75.75v5.3a.448.448,0,0,1-.45.45H5.193a.446.446,0,0,1-.44-.45ZM20.8,21a.755.755,0,0,1-.75.75h-16a.75.75,0,0,1,0-1.5h16A.749.749,0,0,1,20.8,21ZM3.3,3a.749.749,0,0,1,.75-.75h16a.75.75,0,0,1,0,1.5h-16A.755.755,0,0,1,3.3,3Z" />
  </Icon>
)) as IconWithRender;

ViewDensityStandardIcon.displayName = 'ViewDensityStandardIcon';
ViewDensityStandardIcon.renderIcon = (props) => (
  <ViewDensityStandardIcon {...props} />
);
export default ViewDensityStandardIcon;
